import { WaterfallFilterStorage,
  WaterfallFilterType,
  waterfallDateFilterProcessor } from '@bingads-webui-campaign/filter-storage';

/* eslint-disable import/extensions */

/* eslint-disable import/no-unresolved */
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import preferences from '@bingads-webui-component-legacy/preference/service/index';
import _ from 'underscore';
import instrumentationSettings from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import { fetchMCCOverviewRecommendations } from '@bingads-webui-campaign-legacy/dashboard-cards/tips-card/data-fetch';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import { getViewportCardCount, CardState } from '@bingads-webui-campaign/overview-panel';
import { fetchMCCOverview, AccountsMode } from '@bingads-webui-campaign/overview-cards-common';

const cardsConfig = import(/* webpackMode: "eager" */'../webpack-helper-files/cards-config');

export function fetchDataForAccountsOverview(serverContext, resolve, preferenceService, loadingPath) {
  const permissions = {
    ...serverContext.Permissions,
    dynamic: serverContext.DynamicPermissions || {},
  };

  const waterfallFilterStorage = new WaterfallFilterStorage({
    preferenceService,
  });
  let accountsMode = AccountsMode.Expert;

  if (permissions.dynamic.UnifiedProductPhase2) {
    if (loadingPath === '/campaign/vnext/accounts/overview/smart') {
      accountsMode = AccountsMode.Smart;
    } else if (loadingPath === '/campaign/vnext/accounts/overview') {
      const preferenceData = preferenceService.findByNameAtUserLevel('AccountsOverviewAccountMode');

      if ((preferenceData && preferenceData.Data === 'smart') || serverContext.CurrentCustomer.HasExpertAccount === false) {
        accountsMode = AccountsMode.Smart;
      }
    }
  }

  Promise.all([cardsConfig]).then((modules) => {
    const cardState = new CardState({
      navigationLevel: 'customer',
      preferences,
      edm,
      instrumentationSettings,
      instrumentation,
      constants,
      permissions,
      accountsMode,
      newCardsConfig: modules[0].getCardsConfig,
    });

    cardState.fetch().then(() => {
      fetchMCCOverview({
        entitySet: edm.currentCustomer.Accounts,
        dateRange: waterfallDateFilterProcessor(
          waterfallFilterStorage.getFilters([WaterfallFilterType.DateFilter]),
          serverContext
        ),
        jsdata,
        dateUtil,
        getCardsConfig: () => cardState.cards,
        instrumentation,
        constants,
        AccountsOverviewPrefetchQuery: serverContext.AccountsOverviewPrefetchQuery,
        isPreFetch: true,
        permissions,
        accountsMode,
      });
      const viewportCardCount = getViewportCardCount({
        config: cardState.config,
        cards: cardState.cards,
        instrumentation,
        constants,
        isMccLevel: true,
      });
      const viewPortCards = _.first(cardState.cards, viewportCardCount);
      const needsTipsAndOpportunitiesData = _.findIndex(viewPortCards, card => card.id === 'CardType-Tips') !== -1;

      if (needsTipsAndOpportunitiesData) {
        fetchMCCOverviewRecommendations({
          entitySet: edm.currentCustomer.Accounts,
        });
      }

      resolve({ Page: 'AccountsOverview' });
    });
  });
}
